"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import Managerment from "@/views/managements/Managerment.vue";
import MainView from "@/components/layout/MainView.vue";
import UiMenuBar, { MenuController } from "@/components/menu/ManagerMenuBar.vue";
import UserInfo from "./components/UserInfo.vue";
import UserSafe from "./components/UserSafe.vue";
import i18n from "@/lang";
let UserManagement = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menu_controller = new MenuController(
      false,
      [
        {
          index: "UserInfo",
          icon_image: "account_sidebar_1",
          name: i18n.t("accountinfo.user_info_sidebar")
        },
        {
          index: "UserSafe",
          icon_image: "account_sidebar_2",
          name: i18n.t("accountinfo.user_safe_sidebar")
        }
      ],
      "UserInfo"
    );
    this.currentGroup = "";
  }
  changeTeamComponent(data) {
    if (data) {
      this.currentGroup = data;
    }
  }
  changeCollapse() {
  }
  created() {
    return __async(this, null, function* () {
      this.currentGroup = "UserInfo";
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
};
UserManagement = __decorateClass([
  Component({
    components: {
      Managerment,
      MainView,
      UiMenuBar,
      UserInfo,
      UserSafe
    }
  })
], UserManagement);
export {
  UserManagement as default
};
